export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13765.f44dbfcb.jpg";